import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { fetchDashboard } from '../../redux/actions/dashboardActions';
import CONF from '../../config/config';
import apiHandler from '../../utilities/apiHandler';
import { convertToISTEpoch } from '../../utilities/helper';
import ErrorBox from '../../commons/ErrorBox';
import DateSelector from '../../commons/DateSelector';
import PickingTable from '../../commons/PickingTable';
import FulfillmentTable from '../../commons/FulfillmentTable';
import './Tracking.css';

const dateFormatter = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
});

class TrackingScreen extends Component {
    constructor() {
        super();
        this.state = {
            timerId: null,
            data: [],
            tokenArray: [],
            pickingData: [],
            isLoadingPickingData: false,
            pickingDataError: null,
            selectedDeliveryDate: null,
            fulfillmentData: [],
            isLoadingFulfillmentData: false,
            fulfillmentDataError: null,
            proofImageExecutionStepId: '',
            proofImageUrl: null,
            proofImageError: null,
            isLoadingProofUrl: false,
        };
        this.handleDateSelection = this.handleDateSelection.bind(this);
    }
    inframeRef = createRef();
    
    componentDidMount() {
        this.getDashboard();
        if (this.isPickingProgressScreen()) {
            // Set default delivery date to D+1 (tomorrow)
            const tomorrowDate = this.getDefaultDeliveryDate();
            this.setState({ selectedDeliveryDate: tomorrowDate }, () => {
                this.loadPickingData();
            });
            // Load fulfillment data on mount
            this.loadFulfillmentAvailableData();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.state.timerId);
    }

    getTrackingScreenName() {
        const screenName = this.props.location.pathname.slice(1);
        return screenName;
    }

    isPickingProgressScreen() {
        return this.getTrackingScreenName() === 'Picking-Progress';
    }

    isPickingMissingDamagesScreen() {
        return this.getTrackingScreenName() === 'Picking-Missing-Damages';
    }

    fetchProofImageUrl = () => {
        const executionStepId = (this.state.proofImageExecutionStepId || '').trim();
        if (!executionStepId) {
            this.setState({ proofImageError: 'Please enter an execution step Id', proofImageUrl: null });
            return;
        }
        this.setState({ isLoadingProofUrl: true, proofImageError: null, proofImageUrl: null });
        apiHandler
            .get('jobs/job-execution-step/proof-image-url?executionStepId=' + encodeURIComponent(executionStepId))
            .then((response) => {
                const url = response && (response.presignedUrl || response.url || response);
                this.setState({
                    proofImageUrl: typeof url === 'string' ? url : (url && url.url) || null,
                    isLoadingProofUrl: false,
                    proofImageError: null,
                });
            })
            .catch((error) => {
                console.error('Failed to fetch proof image URL', error);
                let errorMessage = 'Failed to fetch proof image URL';
                if (error && error.error && error.error.error) {
                    errorMessage = error.error.error;
                } else if (error && error.message) {
                    errorMessage = error.message;
                }
                this.setState({
                    proofImageError: errorMessage,
                    isLoadingProofUrl: false,
                    proofImageUrl: null,
                });
            });
    };

    
    getDefaultDeliveryDate() {
        var todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        var tomorrowMillis = Date.parse(todayDate) + 86400000; // Add one day (D+1 - tomorrow)
        
        return {
            deliveryDate: dateFormatter.format(tomorrowMillis),
            epochTime: tomorrowMillis,
        };
    }

    
    getDeliveryDates() {
        var selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
        var dates = [];
        
        if (!selectedFacility) return [];

        var todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        var dateMillis = Date.parse(todayDate);

        const daysToAdd = CONF.specialDateFacilitiesD3.includes(selectedFacility.facilityName) ? 3 :
                          CONF.specialDateFacilitiesD2.includes(selectedFacility.facilityName) ? 2 : 1;

        for (var i = 0; i <= daysToAdd; i++) {
            dates.push({
                deliveryDate: dateFormatter.format(dateMillis),
                epochTime: dateMillis,
            });
            dateMillis += 86400000; // Add one day in milliseconds
        }
        return dates;
    }

    handleDateSelection(date) {
        this.setState({ selectedDeliveryDate: date }, () => {
            this.loadPickingData();
        });
    }

    getDashboard() {
        clearTimeout(this.state.timerId);
        const screenName = this.getTrackingScreenName();
        const dashboardID = CONF.DASHBOARD_IDS[screenName];
        this.props.fetchDashboard(dashboardID);
        //NOTE : Removed auto-refresh need to add this in some config file 
        // const customTimeInterval = () => {
        //     const timerId = setTimeout(async () => {
        //         if (!this.props.error) {
        //             this.props.fetchDashboard(dashboardID);
        //             customTimeInterval();
        //         }
        //     }, 300000);
        //     this.setState({ timerId });
        // };
        // customTimeInterval();
    }

    
    loadPickingData = () => {
        const { selectedDeliveryDate } = this.state;
        
        var selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
        if (!selectedFacility || !selectedDeliveryDate) {
            return;
        }

        this.setState({ isLoadingPickingData: true, pickingDataError: null });
        
        const facilityId = selectedFacility.facilityId;
        const promiseDateEpoch = convertToISTEpoch(selectedDeliveryDate.epochTime);
        
        
        apiHandler.get('jobs/pending/picks/info?promiseDate=' + promiseDateEpoch + '&facilityId=' + facilityId)
            .then(response => {
                if (!response || response.length === 0) {
                    this.setState({ 
                        pickingData: [],
                        pickingDataError: 'No pending picks found for the selected date',
                        isLoadingPickingData: false 
                    });
                } else {
                    this.setState({ 
                        pickingData: response, 
                        isLoadingPickingData: false,
                        pickingDataError: null
                    });
                }
            })
            .catch(error => {
                var errorMessage = 'Failed to load picking data';
                
                if (error.error && error.error.error) {
                    errorMessage = error.error.error;
                    if (errorMessage.includes('Internal Server Error because:')) {
                        errorMessage = errorMessage.replace('Internal Server Error because:', '').trim();
                    }
                }
                
                this.setState({ 
                    pickingDataError: errorMessage,
                    isLoadingPickingData: false,
                    pickingData: []
                });
            });
    }

    loadFulfillmentAvailableData = () => {
        var selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
        if (!selectedFacility) {
            return;
        }

        this.setState({ isLoadingFulfillmentData: true, fulfillmentDataError: null });
        
        const facilityId = selectedFacility.facilityId;
        
        apiHandler.get('inventory-item/fulfillment/available?facilityId=' + facilityId)
            .then(response => {
                // Handle response structure: { success, statusCode, data, error }
                const data = response && response.data ? response.data : (Array.isArray(response) ? response : []);
                
                if (!data || data.length === 0) {
                    this.setState({ 
                        fulfillmentData: [],
                        fulfillmentDataError: null,
                        isLoadingFulfillmentData: false 
                    });
                } else {
                    this.setState({ 
                        fulfillmentData: data, 
                        isLoadingFulfillmentData: false,
                        fulfillmentDataError: null
                    });
                }
            })
            .catch(error => {
                var errorMessage = 'Failed to load fulfillment available data';
                
                if (error.error && error.error.error) {
                    errorMessage = error.error.error;
                    if (errorMessage.includes('Internal Server Error because:')) {
                        errorMessage = errorMessage.replace('Internal Server Error because:', '').trim();
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                this.setState({ 
                    fulfillmentDataError: errorMessage,
                    isLoadingFulfillmentData: false,
                    fulfillmentData: []
                });
            });
    }

    refreshAll = () => {
        this.getDashboard();
        if (this.isPickingProgressScreen()) {
            this.loadPickingData();
            this.loadFulfillmentAvailableData();
        }
    }

    renderPickingTable = () => {
        const { pickingData, isLoadingPickingData, pickingDataError } = this.state;
        
        return (
            <PickingTable
                data={pickingData}
                isLoading={isLoadingPickingData}
                error={pickingDataError}
                onRefresh={this.loadPickingData}
                title="Pending Picks Information"
                displayLimit={10}
                sortByKey="pendingQuantity"
                sortOrder="desc"
                loadingTitle="Loading Pending Picks"
                loadingSubtitle="Fetching data from warehouse..."
                loadingTip="This may take a few seconds due to warehouse data processing"
                emptyTitle="No pending picks available"
                emptySubtitle="Try selecting a different delivery date"
                cutoffHint="Pending picks data is refreshed daily at the cutoff time"
            />
        );
    }

    renderFulfillmentTable = () => {
        const { fulfillmentData, isLoadingFulfillmentData, fulfillmentDataError } = this.state;
        
        return (
            <FulfillmentTable
                data={fulfillmentData}
                isLoading={isLoadingFulfillmentData}
                error={fulfillmentDataError}
                onRefresh={this.loadFulfillmentAvailableData}
                title="Fulfillment Available"
                displayLimit={10}
                sortByKey="totalLeftQty"
                sortOrder="desc"
                loadingTitle="Loading Fulfillment Data"
                loadingSubtitle="Fetching available items..."
                loadingTip="This may take a few seconds"
                emptyTitle="No fulfillment items available"
                emptySubtitle="No items available for fulfillment"
            />
        );
    }

    renderDashboard() {
        const { dashboardData } = this.props;
        const { data } = dashboardData;
        const { dashboard_url } = data;
        // let tokenArray = [];
        // if (Array.isArray(data) && data.length > 0) {
        //     tokenArray = data
        //         .filter(({ name, dashboard_jwt_tokens }) => {
        //             return name === this.getTrackingScreenName();
        //         })
        //         .map(({ dashboard_jwt_tokens }) => {
        //             console.log(dashboard_jwt_tokens)
        //             return dashboard_jwt_tokens})
        //         .flat();
        // }
        // if (tokenArray.length > 0) {
        //     return tokenArray.map((url) => (
        // <React.Fragment key={url}>
        return (
            <iframe
                ref={this.inframeRef}
                src={dashboard_url}
                className="iframeStyle"
                title="Tracking Dashboard"
            />
        );
        // </React.Fragment>
        // ));
        // }
        // return [];
    }

    // changeBg() {
    //     if (this.inframeRef.current) {
    //         console.log(
    //             this.inframeRef.current,
    //             JSON.stringify(this.inframeRef.current)
    //         );
    //     }
    // }


    renderProofImageUrlSection = () => {
        const { proofImageExecutionStepId, proofImageUrl, proofImageError, isLoadingProofUrl } = this.state;
        const isSafeUrl = proofImageUrl && /^https?:\/\//i.test(proofImageUrl);
        return (
            <div className="proof-image-url-section">
                <div className="proof-image-url-header">
                    <h3 className="proof-image-url-title">Proof Image </h3>
                    <p className="proof-image-url-subtitle">Fetch proof image by execution step Id</p>
                </div>
                <div className="proof-image-url-row">
                    <label htmlFor="proof-image-execution-step-id" className="proof-image-url-label">Execution Step Id : </label>
                    <input
                        id="proof-image-execution-step-id"
                        type="text"
                        value={proofImageExecutionStepId}
                        onChange={(e) => this.setState({ proofImageExecutionStepId: e.target.value, proofImageError: null })}
                        placeholder="Enter execution step Id"
                        className="proof-image-url-input"
                        onKeyDown={(e) => e.key === 'Enter' && this.fetchProofImageUrl()}
                    />
                    <button
                        type="button"
                        className="proof-image-url-btn"
                        onClick={this.fetchProofImageUrl}
                        disabled={isLoadingProofUrl}
                    >
                        {isLoadingProofUrl ? 'Fetching…' : 'Fetch Image'}
                    </button>
                    {isSafeUrl && (
                        <a href={proofImageUrl} target="_blank" rel="noopener noreferrer" className="proof-image-url-view-link proof-image-url-view-link-right" title="Open proof image in new tab">
                            <span role="img" aria-label="picture">🖼️</span> View Proof Image
                        </a>
                    )}
                </div>
                {proofImageError && (
                    <div className="proof-image-url-result proof-image-url-error">
                        {proofImageError}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { loading, error } = this.props.dashboardData;
        const { pickingDataError, selectedDeliveryDate } = this.state;
        const isPickingProgressScreen = this.isPickingProgressScreen();
        const isPickingMissingDamagesScreen = this.isPickingMissingDamagesScreen();
        
        return (
            <div>
                {isPickingProgressScreen ? (
                    <div className="putaway-header" style={{ marginBottom: '2rem' }}>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 no-padding-xs">
                                <div style={{ textAlign: 'right' }}>
                                    <DateSelector
                                        dates={this.getDeliveryDates()}
                                        selected={selectedDeliveryDate}
                                        classes={'pull-right'}
                                        dateSelected={this.handleDateSelection}
                                    />
                                </div>
                            </div>
                        </div>
                        {!selectedDeliveryDate ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    right: '30px',
                                    top: '64px',
                                    width: '200px',
                                }}
                            >
                                <div className='action-message'>
                                    Select a date for starting the pick job slot generation
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : (
                <React.Fragment>
                    {isPickingMissingDamagesScreen && this.renderProofImageUrlSection()}
                    <div className="buttonContainer">
                        <button
                            className="refreshButton"
                            onClick={() => this.refreshAll()}
                        >
                            <i className="fas fa-redo fa-1x"></i>
                        </button>
                    </div>
                </React.Fragment>
                )}

                {pickingDataError && (
                    <ErrorBox 
                        errorText={pickingDataError} 
                        closeError={() => this.setState({ pickingDataError: null })} 
                    />
                )}

                {isPickingProgressScreen && this.renderPickingTable()}
                {isPickingProgressScreen && this.renderFulfillmentTable()}
             
                {loading ? (
                    <div className="loadingContainer">
                        <div className="lds-hourglass"></div>
                    </div>
                ) : error ? (
                    <h4 className="errorMessage">
                        Sorry we are not able to load dashboard, please click on
                        "Refresh" button
                    </h4>
                ) : (
                    <div>
                        <div className="dashboardContainer">
                            {this.renderDashboard()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dashboardData: state.dashboards,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDashboard: (id) => dispatch(fetchDashboard(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingScreen);



// WEBPACK FOOTER //
// ./src/screens/Tracking/TrackingScreen.js